import { Divider, Grid, Typography, useTheme, Box, Grid2 } from '@mui/material';
import React, { FC, useState } from 'react';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Button } from '../../../Form/Button/button.scomponent';
import { Switch } from '../../../Form/Switch/switch.component';
import { DatePicker } from '../../../Form/DatePicker/date-picker.component';
import { IOrdersListPayload, OrderProductionStatusEnum, OrderStatusEnum } from '../../../../Services/api/orders/orders.interface';
import { IProductsListPayload } from '../../../../Services/api/products/products.interface';
import { TCategoryStore } from '../../../../Services/api/categories/categories.interface';



interface IDrawerComponent extends DrawerProps {
  onToggle: (state: boolean) => void;
  title: string;
  subTitle?: string;
  search?: boolean;
  searchFunction?: () => void;
  titleStyle?: object;
  subTitleStyle?: object;
  open: boolean;
  handleSelect: (payload: IProductsListPayload) => void;
}

const ProductsFilterDrawer: FC<IDrawerComponent> = ({
  onToggle,
  title,
  subTitle,
  open,
  titleStyle = {},
  subTitleStyle = {},
  handleSelect,
}) => {
  const theme = useTheme();
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>(['B2B', 'B2C']);
  const { control } = useForm();

  const handleStatusChange = (status: string) => (checked: boolean) => {
    setSelectedStatuses(prev => {
      if (checked) {
        return [...prev, status];
      }
      return prev.filter(s => s !== status);
    });
  };

  const handleFilterSubmit = () => {
    // Se os 2 status estiverem selecionados, enviar store como undefined
    const storeValue = selectedStatuses.length === 2 ? undefined : selectedStatuses[0] as TCategoryStore;
    handleSelect({ store: storeValue, page: 1 });
    onToggle(false);
  };

  return (
    <Drawer
      open={open}
      onClose={onToggle}
      anchor="right"
      style={{ zIndex: 99999999, flex: 1 }}
    >
      <Grid2 container sx={{ minWidth: '540px', padding: '30px 30px', height: '100%', flex: 1, position: 'relative' }}>
        {/* Conteúdo do Drawer */}
        <Grid2 size={12}>
          <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', ...titleStyle }}>
            {title}
          </Typography>
          {subTitle && (
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: '400',
                color: theme.palette.text.secondary,
                ...subTitleStyle,
              }}
            >
              {subTitle}
            </Typography>
          )}
          <Divider sx={{ marginTop: '20px', marginBottom: '10px' }} />
          <Typography
            sx={{ fontSize: '1rem', fontWeight: 500, color: theme.palette.text.secondary }}
          >
            Loja
          </Typography>
          {[
            { label: 'B2B', value: 'B2B' },
            { label: 'B2C', value: 'B2C' },
            
          ].map((item) => (
            <Grid2 size={12} sx={{ marginTop: '20px' }} key={item.value}>
              <Switch
                label={item.label}
                name={`switch-${item.value}`}
                control={control}
                defaultValue={selectedStatuses.includes(item.value)}
                onChangeCallback={handleStatusChange(item.value)}
              />
            </Grid2>
          ))}
        </Grid2>

        {/* Footer */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '40px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Grid2 container spacing={2} justifyContent="flex-end">
            <Grid2>
              <Button variant="outlined" onClick={() => onToggle(false)} sx={{ width: '120px'}}>
                Cancelar
              </Button>
            </Grid2>
            <Grid2>
              <Button variant="contained" onClick={handleFilterSubmit} sx={{ width: '120px'}}>
                Filtrar
              </Button>
            </Grid2>
          </Grid2>
        </Box>
      </Grid2>
    </Drawer>
  );
};

export { ProductsFilterDrawer };
